
















































import { isEmpty } from 'lodash/fp'
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class AppSectionNavi extends Vue {
  @Prop({ default: '' }) readonly param: string
  @Prop() readonly header!: string
  @Prop() readonly subheaders!: string[]
  @Prop() readonly sections!: {
    name: string;
    url: string;
    allowed: boolean;
  }[]

  @Prop({ default: true }) useRouterPath?: boolean

  toUrl (section, parentPath: string) {
    if (this.useRouterPath) {
      const constructedParentPath = isEmpty(parentPath) ? '' : `${parentPath}/`
      return `${this.rootPath}/${constructedParentPath}${section.path}` // default to this path
    }
    // if there is no need to append the current router path, use this instead
    // more info on https://gitlab.picoded-dev.com/wenconsulting/ifam/frontend-core/-/merge_requests/359
    return this.param ? { name: section.name, params: this.param } : section.path
  }

  get rootPath () {
    const path = this.$router.currentRoute.matched[0].path
    const clientParam = this.$router.currentRoute.params.clientOid
    const userParam = this.$router.currentRoute.params.userOid
    const policyOid = this.$router.currentRoute.params.policyOid
    let returnedPath = path.replace(':userOid', userParam)
    returnedPath = returnedPath.replace(':clientOid', clientParam)
    returnedPath = returnedPath.replace(':policyOid', policyOid)
    return returnedPath
  }

  isSubActive (input) {
    return this.$route.path.endsWith(input)
  }
}
